<template><!-- 商品頁常見問題 -->
    <div id="QA">
        <h2 class="title">常見問題</h2>
        <div class="container">
            <tabs ref="testTabs" :options="{ useUrlFragment: false }" @changed="tabClicked" :key="reloadTabKey" class="functionTabs">
                <tab :title="item.title || 'Default Title'" v-for="(item, index) in tabTitle" :name="item.Name" :key="index"
                     :nav-item-link-class="'qa_tab_accu' + index">
                    <div v-for="(content_item,content_index) in qaContent" :key="content_index">
                        <div class="QFrame" :class="'qa_accu' + index + content_index" @click="qaToggle(content_item)">
                            <div class="Question">
                                <div v-html="content_item.Question"></div>
                                <transition name="fade">
                                    <div class="answer" v-if="content_item.qaShow === true" @click.stop="handleLinkClick">
                                        <div v-html="content_item.Answer"></div>
                                    </div>
                                </transition>
                            </div>
                            <div class="QBtn">
                                <img src="../../assets/arrow.png" :class="{ rotate: content_item.qaShow }" alt="arrow"/>
                            </div>
                        </div>
                    </div>
                </tab>
            </tabs>
            <p class="normalText center">若仍有疑問，請撥打網路服務專線0800-366-168 (服務時間：週一至週五上午8:30-下午5:30，國定假日除外)為您提供協助</p>
            <div class="btnArea">
                <div class="btn center qa_go_accu" @click="goCount1">
                    立即投保
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
        import gtm from "@/utils/gtmDataLayer";
        import {ref ,nextTick} from "vue";
        import {useRouter} from "vue-router";
        import Swal from "sweetalert2";
        import { postApi } from "@/utils/callApi";
        import apiConfig from "@/utils/apiConfig";

        const router = useRouter();
        const reloadTabKey = ref(0);
        const tabTitle = ref([
            {
                Id: process.env.VUE_APP_ENV === 'prod' ? 5 : 4 ,
                Name: "商品相關"
            },
            {
                Id: process.env.VUE_APP_ENV === 'prod' ? 14 :17,
                Name: "投保流程"
            },
            {
                Id: process.env.VUE_APP_ENV === 'prod' ? 16 : 3 ,
                Name: "保單異動"
            },
            {
                Id: process.env.VUE_APP_ENV === 'prod' ? 15 : 18,
                Name: "理賠問題"
            },
            {
                Id: process.env.VUE_APP_ENV === 'prod' ? 10 : 13,
                Name: "會員專區"
            },
        ]);
        const qaContent = ref([
            {
                InsCategory: "",
                QuestionType: 0,
                Id: 0,
                Question: "",
                Answer: ""
            }
        ]);
        const questionType = ref(6);
        const goCount1 =()=> {
            sendDataLayer();
            router.push('/count1');
        }
        const qaToggle= (content) =>{
            content.qaShow = !content.qaShow;
        }

        //取得CMS提供的QA title
        // const getTab = () => {
        //     const data = {
        //         //險別
        //         InsCategory:"Travel"
        //     };
        //     postApi(apiConfig.questionsCategory, null, null, null, data)
        //         .then((response) => {
        //             if(response.data.Code === 200){
        //                 tabTitle.value = response.data.Data.QuestionTab;
        //                 reloadTabKey.value += 1;
        //                 nextTick(() => {
        //                     const tabsContainer = document.querySelector(".functionTabs>.tabs-component-tabs");
        //                     if (tabTitle.value.length > 7) {
        //                         tabsContainer.classList.add("moreThan_7");
        //                         console.log("超過7個");
        //                     }
        //                 });
        //             }
        //         })
        // }

        //取得CMS提供的QA content
        const getQA = () => {
            const data = {
                //險別
                InsCategory:"Travel",
                //類別編號
                QuestionType: questionType.value,
                //回傳筆數限制
                LoadingNum:99,
                //頁面步驟編號(可不傳)
                StepType:null
            };
            if(questionType.value !== "" && questionType.value !== null && questionType.value !== undefined && questionType.value !== 0){
                postApi(apiConfig.getQuestion, null, null, null, data)
                    .then((response) => {
                        if(response.data.Code === 200){
                            qaContent.value = response.data.Data.QuestionAndAnswer
                        }
                    })
            }
        }

        const tabClicked = (index) =>{
            questionType.value = tabTitle.value[index.tab.index].Id
            getQA();
        }

        const sendDataLayer = () => {
            gtm.policyEvent('view_item', 400
                , null, null, null, null
                , 'optional_taiwan', '自行試算');
        }
        const handleLinkClick = (event) => {
            const target = event.target;
            if (target.tagName === "A" && target.dataset.type) {
                event.preventDefault();
                otherAlert(target.dataset.type);
            }
        };
        // getTab();
        getQA();
        // 跳出離開系統提醒視窗
        const otherAlert=(type)=>{
            Swal.fire({
                title: "提醒您",
                showConfirmButton: true,
                showCancelButton: true,
                showCloseButton: true,
                reverseButtons:true,
                cancelButtonText: '返回',
                confirmButtonText: '確認前往',
                html: '<img src="infomark.svg"><p>您即將離開新安東京海上線上投保網站</p>',
            }).then((result) => {
                if (result.isConfirmed) {
                    if(type==='IOS'){
                        window.open('https://support.apple.com/zh-tw/102440','_blank');
                    }else if(type==='ANDROID'){
                        window.open('https://www.adobe.com/tw/acrobat/hub/resources/where-to-find-pdfs-android.html','_blank');
                    }
                } else if (result.isDenied) {
                    Swal.close();
                }
            });
        }
</script>
<style lang="scss">
#QA {
    background-color: $blue-400;
    background-repeat: no-repeat;
    background-position: right bottom;
    padding-bottom: 120px;
    font-weight: bold;

    @media screen and (max-width: $large) {
        background-image: none;
        padding-bottom: 50px;
    }

    .QFrame {
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: left 10px top 15px;
        padding: 15px 10px;
        border: 1px solid #cbd4cf;
        border-radius: 10px;
        width: 100%;
        box-sizing: border-box;
        line-height: 35px;
        margin: 10px 0;
        border-left: 11px solid $blue-700;
        position: relative;
        @media screen and (max-width: $small) {
            font-size: 16px
        }

        .Question {
            width: 94%;
            display: inline-block;
            margin-left: 1%;
            color: $textColor;
            @media screen and (max-width: $small) {
                margin-left: 0;
                width: 85%;
                line-height: 25px;
                padding: 5px;
            }
        }

        .QBtn {
            display: inline-block;
            width: 3%;
            vertical-align: top;
            text-align: center;
            position: absolute;
            right: 3%;
            @media screen and (max-width: $small) {
                width: 5%;
            }

            img {
                display: inline-block;
                margin: 0 auto;

                &.rotate {
                    transform: rotateX(-180deg);
                }

                @media screen and (max-width: $padMini) {
                    width: 100%;
                }
            }
        }

        .answer {
            padding-top: 10px;
            color: $textColor;
            font-weight: 400;
            text-align: justify;

            a {
                color: #3197FA;
                text-decoration: underline;
            }
        }
        .answerLink{
            cursor: pointer;
        }

        .compareTable {
            width: 50%;
            margin: 0 0 30px;
            overflow: hidden;

            li {
                width: 50%;
                text-align: center;
                float: left;
                font-weight: bold;
                color: $textColor;
                display: flex;
                height: 65px;
                justify-content: center;
                padding: 20px 0;
                box-sizing: border-box;
                border-bottom: 1px solid $blue-700;

                &:last-of-type, &:nth-last-child(2) {
                    border: 0
                }

                p {
                    margin: 0 10px;
                }
            }

            @media screen and (max-width: $pad) {
                width: 80%;
            }
            @media screen and (max-width: $small) {
                width: 100%;
            }

            .compareTop {
                background: $lightBlue;
                border: 2px solid $blue-700;
                border-radius: 30px;
                padding: 10px 0;
                overflow: hidden;
                font-size: 24px;
                margin: 10px 0;

                li {
                    padding: 0;
                    border: 0;
                    color: $blue-700;
                    height: auto;
                }

                @media screen and (max-width: $small) {
                    font-size: 18px;
                }
            }

            .title {
                width: 100%;
                background: $blue-700;
                color: #fff;
                font-size: 18px;
                text-align: center;
                justify-content: center;
                padding: 10px;
                height: 55px;
                box-sizing: border-box;

                a {
                    color: $popupYellow;
                    margin-left: 10px;
                    padding: 0;
                    text-decoration: none;
                }

                @media screen and (max-width: $small) {
                    padding: 10px;
                    font-size: 16px;
                    display: block;
                    height: auto;
                    span {
                        width: 100%;
                        display: block;
                    }
                    a {
                        width: 100%;
                        margin: 0;
                        font-size: 13px;
                    }
                }

            }

            .compareMiddle {
                display: block;
                border: 2px solid $blue-700;
                border-radius: $radius;
                box-sizing: border-box;
                overflow: hidden;
                background: #fff;
            }
        }

    }
}
</style>
